import type { Dictionary } from "./dictionary";

export const zh: Dictionary = {
  chartWeeklyDetailHint: "\u6307\u5411\u9031\u671f\u5373\u53ef\u67e5\u770b\u652f\u51fa\u7d44\u6210\u3002",
  chartTrendDetailHint: "\u6307\u5411\u6708\u4efd\u5373\u53ef\u67e5\u770b\u652f\u51fa\u7d44\u6210\u3002",
  language: "語言",
  appTitle: "家庭週預算",
  appSubtitle: "Weekly budget tracker",
  overviewAtGlance: "\u672c\u6708\u6982\u89bd",
  overviewHeadline: "\u672c\u6708\u6982\u89bd",
  overviewFlowCopy: "\u6aa2\u8996\u672c\u6708\u72c0\u614b\u3001\u66f4\u65b0\u4e0b\u4e00\u500b\u9031\u671f\u3001\u518d\u6aa2\u8996\u7d50\u679c\u3002",
  overviewPeriodsTitle: "\u672c\u6708\u7684\u56db\u500b\u6aa2\u67e5\u9ede",
  overviewPeriodsSub: "\u9078\u64c7\u9031\u671f\u4f86\u67e5\u770b\u6216\u958b\u59cb\u4e0b\u4e00\u6b21\u66f4\u65b0\u3002",
  overviewImportTitle: "\u7528\u4e00\u500b\u6b65\u9a5f\u66f4\u65b0\u4e0b\u4e00\u500b\u9031\u671f\u3002",
  openImportFlow: "\u532f\u5165\u672c\u671f\u4ea4\u6613",
  overviewImportStepPaste: "\u8cbc\u4e0a\u4ea4\u6613",
  overviewImportStepReview: "\u78ba\u8a8d\u5206\u985e",
  overviewImportStepSave: "\u5132\u5b58\u9031\u671f",
  periodComplete: "\u5df2\u5b8c\u6210",
  periodNeedsUpdate: "\u9700\u8981\u66f4\u65b0",
  periodNotStarted: "\u5c1a\u672a\u958b\u59cb",
  titleUserFallback: "使用者",
  personalTitleSuffix: "家庭週預算",
  periodControls: "期間",
  workspaceControls: "工作區",
  systemControls: "系統",
  month: "月份",
  selectMonth: "選擇月份",
  addMonth: "新增月份",
  deleteMonth: "移除目前月份",
  overview: "總覽",
  entry: "本週輸入",
  history: "歷史查詢",
  settings: "設定",
  settingsWorkspaceTitle: "帳號與資料設定",
  settingsSectionProfile: "個人資料",
  settingsSectionData: "資料",
  settingsSectionWorkspace: "工作區",
  settingsSectionSecurity: "安全性",
  settingsSectionAdmin: "管理",
  mobileMore: "更多",
  mobileSaveSummary: "準備儲存本期資料",
  currentMonth: "目前月份",
  creditLimit: "信用卡總額度",
  monthSpend: "本月累積支出",
  latestAvailable: "最新可用餘額",
  latestWeekSpend: "最新週總支出",
  monthlyStatus: "本月狀態",
  statusOnTrack: "狀態良好",
  statusWatch: "需要留意",
  statusOver: "超出節奏",
  statusNoData: "等待資料",
  statusOnTrackCopy: "本月花費與上月可比進度相當或更低。",
  statusWatchCopy: "本月花費高於上月可比進度，建議留意主要支出來源。",
  statusOverCopy: "本月花費明顯高於上月可比進度，需要檢查主要支出來源。",
  statusNoDataCopy: "輸入本週資料後，這裡會顯示本月判斷。",
  spendingPace: (used, average, comparison) => `已用 ${used} · 平均每週 ${average} · ${comparison}`,
  samePeriodLower: (change) => `較上月同期 ${change}`,
  samePeriodHigher: (change) => `較上月同期 +${change}`,
  samePeriodUnavailable: "缺少上月同期資料",
  sameProgressLower: (change) => `較上月同進度 ${change}`,
  sameProgressHigher: (change) => `較上月同進度 +${change}`,
  sameProgressUnavailable: "缺少上月同進度資料",
  lastMonthLower: (change) => `較上月 ${change}`,
  lastMonthHigher: (change) => `較上月 +${change}`,
  lastMonthUnavailable: "缺少上月資料",
  selectedPeriodComparison: "所選週期比較",
  periodComparisonLower: (change) => `-${change} vs 上月同週期`,
  periodComparisonHigher: (change) => `+${change} vs 上月同週期`,
  periodComparisonFlat: "與上月同週期相同",
  periodComparisonUnavailable: "此週期沒有可比較的上月同週期資料。",
  latestPeriodChange: "最新週變化",
  comparedSamePeriod: "與上月同週相比",
  largestDriver: "本週顯著支出",
  topDriversLine: (first, second) => (second ? `本週顯著支出：${first} · ${second}` : `本週顯著支出：${first}`),
  noDriverYet: "本週尚無顯著支出",
  noPeriodDriverYet: "此週期尚無顯著支出",
  topMonthlyDriversLine: (first, second) =>
    second ? `本月顯著支出：${first} · ${second}` : `本月顯著支出：${first}`,
  noMonthlyDriverYet: "本月尚無顯著支出",
  nextAction: "下一步",
  nextActionUpdate: "更新本週資料",
  nextActionReview: (driver) => `檢查${driver}`,
  nextActionWatch: "留意下一週支出",
  openWeeklyEntry: "開啟週輸入",
  onboardingTitle: "歡迎使用",
  onboardingCopy: "歡迎使用。先新增月份並輸入第一週餘額，就能看到本月狀態。",
  emptyChartCopy: "輸入第一週餘額後，這裡會建立圖表。",
  emptyWeeksCopy: "目前還沒有完成的週紀錄。",
  weeklyComposition: "每週支出組成",
  weeklyCompositionSub: "非採買、採買與意外支出堆疊比較",
  chartZoom: "放大圖表",
  chartRestore: "回復圖表",
  monthlyTrend: "月支出趨勢",
  monthlyTrendSub: "以月份比較採買、非採買與意外支出",
  historyCategoryChartTitle: "月份分類金額",
  historyCategoryChartSub: "各分類支出加總，區塊大小與顏色深淺代表金額",
  chartShareLabel: "佔比",
  needTwoMonths: "需要至少兩個月份才有趨勢",
  monthlyTotal: "月總支出",
  total: "總計",
  monthWeeks: "月份週紀錄",
  period: "週期",
  to: "至",
  cumulative: "本月累積",
  weeklyTotal: "當週總支出",
  nonGrocery: "非採買",
  grocery: "採買",
  incidentals: "意外",
  notes: "備註",
  edit: "編輯",
  unnamedPeriod: "未命名週次",
  entryEyebrow: "週次編輯",
  entryTitle: "本週輸入",
  saveWeek: "儲存週次",
  clearPeriod: "清除本期紀錄",
  updateThisWeek: "更新本週",
  updateThisWeekSub: "先輸入本週基本資料，再確認系統計算出的金額。",
  liveSummary: "即時計算",
  calculatedTotals: "計算結果",
  thisPeriodSpend: "本期支出",
  entryMonthSpend: "本月支出",
  liveSummaryCopy: "輸入可用餘額與上月待繳後，上方卡片會即時更新。",
  availableFormula: "信用卡總額度 - 可用餘額 - 上月待繳",
  periodFormula: "目前本月支出 - 前一期本月支出",
  weekData: "週資料",
  weekDataSub: "輸入累積值後，當週總支出會自動推算",
  editPeriod: "編輯週次",
  availableBalance: "可用餘額",
  cumulativeAfterUnpaid: "本月總支出(扣除上月待繳)",
  unpaidPrevious: "上月待繳(如有)",
  categoryAmounts: "分類金額",
  categoryAmountsSub: "保留完整明細分類；採買支出會依公式自動計算。",
  groceryExplainer: "採買會由本期總支出扣除明細非採買與意外支出後自動計算。",
  transactionImportTitle: "匯入交易草稿",
  transactionImportSub: "貼上銀行或信用卡交易，先審核草稿，再套用到目前週期。",
  currentPeriod: "目前週期",
  pasteTransactions: "貼上交易資料",
  parseTransactions: "解析交易",
  applyConfirmedRows: "套用已確認交易",
  includedRows: "已納入",
  needsReviewRows: "需審核",
  excludedRows: "已排除",
  importSummaryLine: (count, amount) => `${count} 筆 · ${amount}`,
  merchantDescription: "店家 / 說明",
  suggestedCategory: "建議分類",
  confidence: "信心",
  reason: "原因",
  action: "操作",
  includeTransaction: "納入",
  noImportRows: "這個區塊目前沒有交易。",
  importParseEmpty: "請先貼上交易資料。",
  importApplied: (count) => `已套用 ${count} 筆交易到目前草稿。`,
  importBalancesUpdated: "已從貼上內容更新可用餘額與未繳金額。",
  importNeedsPeriod: "請先設定 Period start 和 Period end。",
  importBalanceWarning: (importTotal, periodTotal) =>
    `匯入交易合計為 ${importTotal}，但目前餘額推算的本期支出為 ${periodTotal}。請檢查待入帳交易、退款或日期界線。`,
  importGroceryWarning: (importGrocery, residualGrocery) =>
    `匯入採買合計為 ${importGrocery}，目前公式推算採買為 ${residualGrocery}。採買仍會依既有公式計算。`,
  confidenceHigh: "高",
  confidenceMedium: "中",
  confidenceLow: "低",
  reasonLabels: {
    "outside selected period": "超出目前週期",
    "month not created": "月份尚未建立",
    "no matching existing period": "沒有符合的既有週期",
    "invalid date": "日期無效",
    "positive amount / payment / refund": "正數金額 / 繳款 / 退款",
    "duplicate candidate": "可能重複",
    "unsupported row format": "不支援的列格式",
    "low confidence": "低信心，需要確認",
    "incidentals require confirmation": "意外支出需要確認",
    "user excluded": "使用者排除",
  },
  otherDetails: "突發事件或少見意外支出備註",
  incidentalsDetailsTitle: "意外 / 少見事件備註",
  incidentalsDetailsSub: "只在少見、不可避免、突發事件時填寫。",
  incidentalsRareHint: "少見、不可避免、突發事件，例如緊急維修、突發醫療或事故相關費用。",
  searchEyebrow: "查詢",
  pastRecords: "過去紀錄",
  historyOverviewTab: "總覽",
  historyTransactionsTab: "交易",
  allMonths: "全部月份",
  allCategories: "全部分類",
  category: "分類",
  keyword: "關鍵字",
  keywordPlaceholder: "週期、備註、分類",
  merchant: "商家",
  merchantPlaceholder: "搜尋商家或說明",
  startDate: "開始日期",
  endDate: "結束日期",
  allPeriods: "全部週期",
  noTransactions: "沒有符合條件的交易",
  transactionWorkspaceScope: "目前工作區",
  transactionDate: "交易日期",
  transactionContext: "月份 / 週期",
  transactionContextLine: (month, period) => `${month} · ${period}`,
  notesPlaceholder: "例如：緊急維修 $金額\n突發費用 $金額",
  minAmount: "最低金額",
  amount: "金額",
  noRecords: "沒有符合條件的紀錄",
  dataSettingsTitle: "資料與分類設定",
  monthData: "目前月份資料",
  monthDataSub: "這些設定會儲存在後端資料檔",
  saveSettings: "儲存設定",
  monthName: "月份名稱",
  backup: "資料備份",
  backupSub: "可將目前資料匯出，或匯入語言模型/備份產生的資料",
  exportJson: "匯出資料 JSON",
  importJson: "匯入資料 JSON",
  categorySettings: "分類設定",
  categorySettingsSub: "系統分類保持穩定，工作區可新增、重新命名或封存分類。",
  type: "類型",
  ruleHint: "規則提示",
  categoryName: "分類名稱",
  categoryNamePlaceholder: "例如：寵物",
  categoryType: "分類群組",
  categoryHint: "分類說明",
  categoryHintPlaceholder: "例如：醫療、食品、美容",
  addCategory: "新增分類",
  categoryStatus: "狀態",
  categoryActiveStatus: "使用中",
  categoryArchivedStatus: "已封存",
  categorySystemStatus: "系統",
  categoryEdit: "編輯",
  categoryArchive: "封存",
  categoryRestore: "恢復",
  categoryAdded: "分類已新增。",
  categorySaved: "分類已儲存。",
  categoryArchived: "分類已封存。",
  categoryRestored: "分類已恢復。",
  categoryNameInvalid: "請輸入至少 2 個字的分類名稱。",
  categoryEditTitle: "編輯分類",
  categoryEditNamePrompt: "請更新分類名稱。",
  categoryEditHintPrompt: "請更新分類說明。",
  categoryArchiveTitle: "封存分類",
  categoryArchiveConfirm: (category) => `要封存「${category}」嗎？既有紀錄仍會保留顯示。`,
  autoCalculated: "自動計算",
  incidentalType: "意外支出",
  categoryLabels: {
    medical: "醫療自費",
    privateInsurance: "私保",
    electricity: "電費",
    gas: "瓦斯費",
    internetMobile: "網路手機費(含服務訂閱)",
    water: "水費",
    school: "學費",
    homeInsurance: "房屋險",
    carInsurance: "車險",
    transport: "交通費用",
    government: "政府費用",
    shoppingDining: "購物外食",
    incidentals: "當周意外支出",
  },
  deleteOnlyMonth: "至少需要保留一個月份。",
  deleteConfirm: (name) => `確定要移除「${name}」嗎？這會刪除該月份的所有週紀錄。`,
  clearPeriodConfirm: (period) => `確定要清除「${period}」的所有紀錄嗎？這會一併刪除分類金額、備註與交易紀錄。`,
  periodCleared: (period) => `已清除${period}的所有紀錄。`,
  importFailed: "匯入失敗，請確認 JSON 格式正確。",
  dialogNoticeTitle: "提示",
  dialogConfirmTitle: "請確認",
  dialogOk: "確定",
  dialogConfirm: "確定",
  createWorkspaceTitle: "新增工作區",
  firstPeriod: "Period 1",
  secondPeriod: "Period 2",
  thirdPeriod: "Period 3",
  fourthPeriod: "Period 4",
  buildVersion: "Build version",
  editingPeriod: (period) => `正在編輯：${period}`,
  editingExistingPeriod: "正在編輯既有週期；儲存後會覆蓋目前數值。",
  periodTimelineWarning:
    "\u5075\u6e2c\u5230\u9031\u671f\u65e5\u671f\u6709\u91cd\u758a\u6216\u7f3a\u53e3\u3002\u7cfb\u7d71\u4e0d\u6703\u963b\u6b62\u5132\u5b58\uff0c\u4f46\u9700\u7531\u4f60\u81ea\u884c\u78ba\u8a8d\u4e26\u4fee\u6b63\u6642\u9593\u7dda\u3002",
  saveSuccess: "已儲存本週資料",
  saveSuccessDetailed: (period, total, grocery) => `已儲存 ${period}：本期總支出 ${total}，採買 ${grocery}。`,
  loginRequired: "需要登入",
  loginTitle: "輸入密碼",
  loginSub: "這份家庭預算受密碼保護；請向家庭預算管理者取得密碼。",
  checkingAccess: "\u6aa2\u67e5\u5b58\u53d6",
  checkingAccessTitle: "\u6b63\u5728\u6e96\u5099\u4f60\u7684\u5de5\u4f5c\u5340...",
  loginAccountId: "\u5e33\u865f ID\uff08\u9078\u586b\uff09",
  password: "密碼",
  login: "登入",
  logout: "登出",
  cancel: "取消",
  loginFailed: "密碼不正確，請再試一次。",
  workspace: "\u5de5\u4f5c\u5340",
  workspaceSwitching: "\u5207\u63db\u4e2d...",
  workspaceSwitched: "\u5df2\u5207\u63db\u5de5\u4f5c\u5340",
  workspaceSwitchFailed: "\u7121\u6cd5\u5207\u63db\u5de5\u4f5c\u5340\uff0c\u8acb\u518d\u8a66\u4e00\u6b21\u3002",
  createWorkspace: "\u65b0\u589e\u5de5\u4f5c\u5340",
  createWorkspacePrompt: "\u8acb\u8f38\u5165\u65b0\u5de5\u4f5c\u5340\u540d\u7a31",
  createWorkspaceFailed: "\u7121\u6cd5\u65b0\u589e\u5de5\u4f5c\u5340\uff0c\u8acb\u518d\u8a66\u4e00\u6b21\u3002",
  workspaceManagementTitle: "\u5de5\u4f5c\u5340\u7ba1\u7406",
  workspaceManagementSub: "\u91cd\u65b0\u547d\u540d\u6216\u522a\u9664\u9019\u500b\u5e33\u865f\u64c1\u6709\u7684\u5de5\u4f5c\u5340\u3002",
  workspaceActions: "\u5de5\u4f5c\u5340\u64cd\u4f5c",
  today: "\u4eca\u65e5",
  guidedIntroMonthMenuTitle: "\u7b2c\u4e00\u6b65 \u2014 \u9078\u64c7\u6708\u4efd",
  guidedIntroMonthMenuBody: "\u958b\u555f\u6708\u4efd\u65c1\u7684\u4e09\u9ede\u9078\u55ae\uff0c\u5c31\u80fd\u65b0\u589e\u6216\u522a\u9664\u6708\u4efd\u3002\u65b0\u589e\u6708\u4efd\u5f8c\uff0c\u7cfb\u7d71\u6703\u5efa\u7acb\u4e0b\u4e00\u6b21\u66f4\u65b0\u6240\u9700\u7684\u6bcf\u9031\u8f38\u5165\u6b04\u4f4d\u3002",
  guidedIntroImportTitle: "\u7b2c\u4e09\u6b65 \u2014 \u532f\u5165\u4e0b\u4e00\u671f",
  guidedIntroImportBody: "\u6bcf\u6b21\u66f4\u65b0\u90fd\u5f9e\u9019\u88e1\u958b\u59cb\u3002\u8cbc\u4e0a\u9280\u884c\u6216\u4fe1\u7528\u5361\u4ea4\u6613\uff0c\u78ba\u8a8d\u5206\u985e\u5f8c\uff0c\u518d\u5132\u5b58\u9019\u6b21\u671f\u9593\u3002",
  renameWorkspace: "\u91cd\u65b0\u547d\u540d\u5de5\u4f5c\u5340",
  renameWorkspaceTitle: "\u91cd\u65b0\u547d\u540d\u5de5\u4f5c\u5340",
  renameWorkspacePrompt: "\u8acb\u8f38\u5165\u65b0\u7684\u5de5\u4f5c\u5340\u540d\u7a31。",
  deleteWorkspace: "\u522a\u9664\u5de5\u4f5c\u5340",
  workspaceRenameSuccess: "\u5de5\u4f5c\u5340\u5df2\u91cd\u65b0\u547d\u540d\u3002",
  workspaceRenameFailed: "\u7121\u6cd5\u91cd\u65b0\u547d\u540d\u5de5\u4f5c\u5340\uff0c\u8acb\u6aa2\u67e5\u540d\u7a31\u5f8c\u518d\u8a66\u4e00\u6b21\u3002",
  workspaceDeleteConfirm: (name) => `\u78ba\u5b9a\u8981\u522a\u9664\u300c${name}\u300d\u55ce\uff1f\u9019\u6703\u6c38\u4e45\u79fb\u9664\u6b64\u5de5\u4f5c\u5340\u7684\u8cc7\u6599\u3002`,
  workspaceDeleteSuccess: "\u5de5\u4f5c\u5340\u5df2\u522a\u9664\u3002",
  workspaceDeleteFailed: "\u7121\u6cd5\u522a\u9664\u5de5\u4f5c\u5340\uff0c\u8acb\u78ba\u8a8d\u4e0d\u662f\u9810\u8a2d\u6216\u6700\u5f8c\u4e00\u500b\u5de5\u4f5c\u5340\u3002",
  accountAdminTitle: "\u5e33\u865f\u7ba1\u7406",
  accountAdminSub: "\u5efa\u7acb\u5167\u90e8\u5bc6\u78bc\u5e33\u865f\uff0c\u4e26\u7ba1\u7406 Google \u8a66\u7528\u4f7f\u7528\u8005\u7684\u5b58\u53d6\u72c0\u614b\u3002",
  accountId: "\u5e33\u865f ID",
  displayName: "\u986f\u793a\u540d\u7a31",
  emailOptional: "Email\uff08\u9078\u586b\uff09",
  workspaceName: "\u5de5\u4f5c\u5340\u540d\u7a31",
  temporaryPassword: "\u81e8\u6642\u5bc6\u78bc",
  createAccount: "\u5efa\u7acb\u5e33\u865f",
  accountCreateSaving: "\u5efa\u7acb\u4e2d...",
  accountCreateSuccess: (account, workspace) => `\u5df2\u5efa\u7acb ${account}\uff0c\u4e26\u958b\u555f\u5de5\u4f5c\u5340 ${workspace}\u3002`,
  accountCreateFailed: "\u7121\u6cd5\u5efa\u7acb\u5e33\u865f\uff0c\u8acb\u6aa2\u67e5\u8f38\u5165\u5167\u5bb9\u5f8c\u518d\u8a66\u4e00\u6b21\u3002",
  accountCreateDuplicate: "\u9019\u500b\u5e33\u865f ID \u5df2\u5b58\u5728\uff0c\u8acb\u6539\u7528\u5176\u4ed6 ID\u3002",
  accountLoginHint: "\u8acb\u5c07\u81e8\u6642\u5bc6\u78bc\u4ee5\u5b89\u5168\u9014\u5f91\u4ea4\u7d66\u4f7f\u7528\u8005\uff1b\u7cfb\u7d71\u4e0d\u6703\u986f\u793a\u6216\u5132\u5b58\u660e\u78bc\u3002",
  managedUsersTitle: "\u4f7f\u7528\u8005",
  managedUsersSub: "\u6aa2\u8996 Google \u8a66\u7528\u4f7f\u7528\u8005\uff0c\u4e26\u5c07\u5df2\u6838\u53ef\u4f7f\u7528\u8005\u5347\u7d1a\u70ba\u6b63\u5f0f\u5b58\u53d6\u3002",
  managedUsersEmpty: "\u76ee\u524d\u6c92\u6709\u5176\u4ed6\u4f7f\u7528\u8005\u3002",
  promoteToStandard: "\u5347\u7d1a\u70ba\u6b63\u5f0f",
  accountPromoteSuccess: (account) => `\u5df2\u5c07 ${account} \u5347\u7d1a\u70ba\u6b63\u5f0f\u5b58\u53d6\u3002`,
  accountPromoteFailed: "\u7121\u6cd5\u66f4\u65b0\u4f7f\u7528\u8005\u72c0\u614b\uff0c\u8acb\u518d\u8a66\u4e00\u6b21\u3002",
  deleteAccount: "\u522a\u9664\u5e33\u865f",
  accountDeleteConfirm: (account) => `\u78ba\u5b9a\u8981\u522a\u9664\u300c${account}\u300d\u55ce\uff1f\u9019\u6703\u6c38\u4e45\u79fb\u9664\u8a72\u4f7f\u7528\u8005\u7684\u5de5\u4f5c\u5340\u8207\u4f3a\u670d\u5668\u8cc7\u6599\u3002`,
  accountDeleteSuccess: (account) => `\u5df2\u522a\u9664 ${account} \u548c\u5c08\u5c6c\u5de5\u4f5c\u5340\u3002`,
  accountDeleteFailed: "\u7121\u6cd5\u522a\u9664\u5e33\u865f\uff0c\u8acb\u518d\u8a66\u4e00\u6b21\u3002",
  noActionNeeded: "\u7121\u9700\u64cd\u4f5c",
  accountResetTitle: "\u7ba1\u7406\u54e1\u5bc6\u78bc\u91cd\u8a2d",
  accountResetSub: "\u7576\u4f7f\u7528\u8005\u9700\u8981\u6062\u5fa9\u5b58\u53d6\u6642\uff0c\u66ff\u5bc6\u78bc\u5e33\u865f\u8a2d\u5b9a\u65b0\u7684\u81e8\u6642\u5bc6\u78bc\u3002",
  accountToReset: "\u8981\u91cd\u8a2d\u7684\u5e33\u865f",
  newTemporaryPassword: "\u65b0\u81e8\u6642\u5bc6\u78bc",
  confirmTemporaryPassword: "\u78ba\u8a8d\u81e8\u6642\u5bc6\u78bc",
  resetAccountPassword: "\u91cd\u8a2d\u5bc6\u78bc",
  accountResetNoAccounts: "\u76ee\u524d\u6c92\u6709\u53ef\u91cd\u8a2d\u7684\u5176\u4ed6\u5bc6\u78bc\u5e33\u865f\u3002",
  accountResetSaving: "\u91cd\u8a2d\u4e2d...",
  accountResetSuccess: (account) => `\u5df2\u66ff ${account} \u91cd\u8a2d\u5bc6\u78bc\u3002`,
  accountResetFailed: "\u7121\u6cd5\u91cd\u8a2d\u5bc6\u78bc\uff0c\u8acb\u78ba\u8a8d\u5e33\u865f\u8207\u65b0\u5bc6\u78bc\u3002",
  accountSecurityTitle: "\u5e33\u865f\u5b89\u5168",
  accountSecuritySub: "\u8b8a\u66f4\u76ee\u524d\u767b\u5165\u5e33\u865f\u7684\u5bc6\u78bc\u3002",
  profileTitle: "\u500b\u4eba\u8cc7\u6599",
  profileSub: "\u66f4\u65b0\u61c9\u7528\u7a0b\u5f0f\u4e2d\u986f\u793a\u7684\u540d\u7a31\u3002",
  guidedIntroHelpTitle: "\u65b0\u624b\u5c0e\u89bd",
  guidedIntroHelpSub: "\u7b2c\u4e00\u6b21\u767b\u5165\u7684\u6559\u5b78\u53ea\u6703\u81ea\u52d5\u51fa\u73fe\u4e00\u6b21\uff0c\u4e4b\u5f8c\u9700\u8981\u6642\u53ef\u4ee5\u5728\u9019\u88e1\u91cd\u65b0\u64ad\u653e\u3002",
  guidedIntroReplay: "\u91cd\u65b0\u64ad\u653e\u5c0e\u89bd",
  guidedIntroLabel: "\u65b0\u624b\u5c0e\u89bd",
  guidedIntroBack: "\u4e0a\u4e00\u6b65",
  guidedIntroNext: "\u4e0b\u4e00\u6b65",
  guidedIntroFinish: "\u5b8c\u6210\u5c0e\u89bd",
  guidedIntroSkip: "\u5148\u7565\u904e",
  guidedIntroProgress: (current, total) => `\u6b65\u9a5f ${current} / ${total}`,
  guidedIntroWelcomeTitle: (name) => `${name}\uff0c\u6b61\u8fce\u958b\u59cb`,
  guidedIntroWelcomeBody:
    "\u9019\u662f\u4f60\u7684\u5bb6\u5ead\u9031\u9810\u7b97\u8ffd\u8e64\u7cfb\u7d71\u3002\u6bcf\u9031\u82b1 2 \u5206\u9418\u8a18\u9304\u82b1\u8cbb\uff0c\u7cfb\u7d71\u81ea\u52d5\u5e6b\u4f60\u5efa\u7acb\u5716\u8868\u548c\u5206\u6790\u3002\u8ddf\u8457\u4e0b\u9762 5 \u500b\u6b65\u9a5f\uff0c\u9a6c\u4e0a\u4e0a\u624b\u3002",
  guidedIntroStep2Title: "\u7b2c\u4e00\u6b65 \u2014 \u65b0\u589e\u6708\u4efd",
  guidedIntroStep2Body:
    "\u9ede\u5de6\u4e0a\u89d2\u7684\u300c\u65b0\u589e\u6708\u4efd\u300d\u5efa\u7acb\u672c\u6708\u6846\u67b6\uff0c\u7cfb\u7d71\u81ea\u52d5\u70ba\u6bcf\u9031\u5efa\u7acb\u8f38\u5165\u6b04\u4f4d\uff0c\u7b49\u4f60\u6bcf\u9031\u4f86\u586b\u5165\u3002",
  guidedIntroStep3Title: "\u7b2c\u4e8c\u6b65 \u2014 \u8a2d\u5b9a\u4fe1\u7528\u5361\u984d\u5ea6",
  guidedIntroStep3Body:
    "\u5728\u8a2d\u5b9a \u2192 \u8cc7\u6599 \u88e1\uff0c\u8f38\u5165\u4f60\u7684\u4fe1\u7528\u5361\u7e3d\u984d\u5ea6\u3002\u9019\u662f\u7cfb\u7d71\u8a08\u7b97\u53ef\u7528\u9918\u984d\u548c\u6708\u652f\u51fa\u7684\u57fa\u6e96\u3002",
  guidedIntroStep4Title: "\u7b2c\u4e09\u6b65 \u2014 \u6bcf\u9031\u8f38\u5165\u82b1\u8cbb",
  guidedIntroStep4Body:
    "\u9ede\u4e0a\u65b9\u300c\u672c\u9031\u8f38\u5165\u300d\uff0c\u586b\u5165\u5404\u985e\u5225\u7684\u82b1\u8cbb\u91d1\u984d\u3002\u5132\u5b58\u5f8c\uff0c\u7e3d\u89bd\u9801\u99ac\u4e0a\u986f\u793a\u672c\u6708\u72c0\u614b\uff0c\u544a\u8a34\u4f60\u76ee\u524d\u662f\u5426\u5728\u9810\u7b97\u7bc4\u570d\u5167\u3002",
  guidedIntroStep5Title: "\u7b2c\u56db\u6b65 \u2014 \u6708\u7d50\u5224\u8b80",
  guidedIntroStep5Body:
    "\u6bcf\u9031\u8cc7\u6599\u5b58\u6a94\u5f8c\uff0c\u9019\u500b\u5340\u584a\u6703\u5373\u6642\u6574\u7406\u672c\u6708\u72c0\u614b\uff0c\u544a\u8a34\u4f60\u76ee\u524d\u662f\u5426\u5728\u7bc0\u594f\u5167\uff0c\u4ee5\u53ca\u503c\u5f97\u7559\u610f\u7684\u4e3b\u8981\u652f\u51fa\u3002",
  guidedIntroStep6Title: "\u7b2c\u4e94\u6b65 \u2014 \u6708\u8da8\u52e2\u5716",
  guidedIntroStep6Body:
    "\u586b\u5165 2\u20133 \u500b\u6708\u7684\u9031\u7d00\u9304\u5f8c\uff0c\u6708\u8da8\u52e2\u5716\u81ea\u52d5\u751f\u6210\u3002\u76ee\u524d\u4f60\u9084\u6c92\u6709\u8cc7\u6599\uff0c\u6301\u7e8c\u8a18\u9304\u5e7e\u9031\u5f8c\u5716\u8868\u5c31\u6703\u51fa\u73fe\u3002",
  guidedIntroFinishTitle: "\u4f60\u5df2\u6e96\u5099\u597d\u4e86\uff01",
  guidedIntroFinishBody:
    "\u8a2d\u5b9a\u9801\u9084\u6709\u532f\u5165\u532f\u51fa\u529f\u80fd\uff0c\u65b9\u4fbf\u5728\u5bb6\u4eba\u4e4b\u9593\u540c\u6b65\u8cc7\u6599\u3002\u73fe\u5728\u53bb\u65b0\u589e\u672c\u6708\uff0c\u958b\u59cb\u8a18\u9304\u7b2c\u4e00\u9031\u5427\uff01",
  guidedIntroEntryTitle: "\u5f9e\u6bcf\u9031\u8f38\u5165\u958b\u59cb",
  guidedIntroEntryBody:
    "\u6bcf\u6b21\u66f4\u65b0\u6642\uff0c\u5148\u5230\u9019\u88e1\u8f38\u5165\u672c\u9031\u53ef\u7528\u9918\u984d\u3001\u4e0a\u6708\u5f85\u7e73\u8207\u5404\u5206\u985e\u91d1\u984d\u3002\u9019\u88e1\u662f\u6574\u500b\u7cfb\u7d71\u7684\u8d77\u9ede\u3002",
  guidedIntroStatusTitle: "\u6708\u7d50\u5224\u8b80\u6703\u81ea\u52d5\u6574\u7406",
  guidedIntroStatusBody:
    "\u6bcf\u9031\u8cc7\u6599\u5b58\u6a94\u5f8c\uff0c\u9996\u9801\u6703\u5373\u6642\u6574\u7406\u672c\u6708\u72c0\u614b\uff0c\u544a\u8a34\u4f60\u76ee\u524d\u662f\u5426\u5728\u7bc0\u594f\u5167\uff0c\u4ee5\u53ca\u503c\u5f97\u7559\u610f\u7684\u4e3b\u8981\u652f\u51fa\u3002",
  guidedIntroChartsTitle: "\u5716\u8868\u4f86\u81ea\u4f60\u8f38\u5165\u7684\u8cc7\u6599",
  guidedIntroChartsBody:
    "\u9031\u5716\u8207\u6708\u5716\u4e0d\u662f\u624b\u52d5\u7dad\u8b77\uff0c\u800c\u662f\u6839\u64da\u6bcf\u9031\u8f38\u5165\u81ea\u52d5\u751f\u6210\u3002\u8cc7\u6599\u8d8a\u5b8c\u6574\uff0c\u9019\u88e1\u5c31\u8d8a\u6709\u53c3\u8003\u50f9\u503c\u3002",
  guidedIntroWorkspaceTitle: "\u5de5\u4f5c\u5340\u662f\u4f60\u7684\u9810\u7b97\u5834\u666f",
  guidedIntroWorkspaceBody:
    "\u4f60\u53ef\u4ee5\u7528\u4e0d\u540c\u5de5\u4f5c\u5340\u5340\u5206\u4e0d\u540c\u5bb6\u5ead\u3001\u7528\u9014\u6216\u6e2c\u8a66\u8cc7\u6599\u3002\u5207\u63db\u5de5\u4f5c\u5340\u6642\uff0c\u770b\u5230\u7684\u662f\u8a72\u5de5\u4f5c\u5340\u81ea\u5df1\u7684\u5167\u5bb9\u3002",
  guidedIntroSettingsTitle: "\u8a2d\u5b9a\u5340\u53ef\u4ee5\u56de\u982d\u8abf\u6574",
  guidedIntroSettingsBody:
    "\u9019\u88e1\u53ef\u4ee5\u8655\u7406\u8a9e\u8a00\u3001\u986f\u793a\u540d\u7a31\u3001\u5b89\u5168\u8a2d\u5b9a\uff0c\u4e26\u5728\u4e4b\u5f8c\u9700\u8981\u6642\u91cd\u65b0\u64ad\u653e\u9019\u4efd\u5c0e\u89bd\u3002",
  currentPassword: "\u76ee\u524d\u5bc6\u78bc",
  newPassword: "\u65b0\u5bc6\u78bc",
  confirmNewPassword: "\u78ba\u8a8d\u65b0\u5bc6\u78bc",
  changePassword: "\u8b8a\u66f4\u5bc6\u78bc",
  passwordChangeSuccess: "\u5bc6\u78bc\u5df2\u66f4\u65b0\u3002\u4e0b\u6b21\u767b\u5165\u8acb\u4f7f\u7528\u65b0\u5bc6\u78bc\u3002",
  passwordChangeFailed: "\u7121\u6cd5\u66f4\u65b0\u5bc6\u78bc\uff0c\u8acb\u78ba\u8a8d\u76ee\u524d\u5bc6\u78bc\u8207\u65b0\u5bc6\u78bc\u3002",
  passwordMismatch: "\u65b0\u5bc6\u78bc\u8207\u78ba\u8a8d\u5bc6\u78bc\u4e0d\u76f8\u7b26\u3002",
  signedInAccount: "\u76ee\u524d\u767b\u5165\u5e33\u865f",
  signInMethod: "\u767b\u5165\u65b9\u5f0f",
  accountStatus: "\u5e33\u865f\u72c0\u614b",
  trialAccount: "\u8a66\u7528",
  activeAccount: "\u6b63\u5f0f",
  continueWithGoogle: "\u4f7f\u7528 Google \u7e7c\u7e8c",
  orPasswordLogin: "\u6216\u4f7f\u7528\u5bc6\u78bc\u767b\u5165",
  landingEyebrow: "\u79c1\u4eba\u8a66\u7528\u7248\u672c",
  landingHeadline: "\u6bcf\u9031\u9810\u7b97\uff0c\u4e00\u773c\u770b\u6e05\u3002",
  landingCopy: "\u4ee5\u7c21\u55ae\u3001\u6e05\u695a\u3001\u512a\u96c5\u7684\u65b9\u5f0f\u8655\u7406\u6708\u5ea6\u638c\u63e1\u3001\u6bcf\u9031\u8f38\u5165\u8207\u4ea4\u6613\u6aa2\u8996\u3002",
  landingStartTrialAccess: "\u958b\u59cb\u8a66\u7528",
  landingStartWithGoogle: "\u4f7f\u7528 Google \u958b\u59cb",
  landingContactUs: "\u806f\u7d61\u6211\u5011",
  landingPillStatement: "\u6708\u7d50\u6458\u8981",
  landingPillTrend: "\u8da8\u52e2\u5716\u8868",
  landingPillReview: "\u4ea4\u6613\u6aa2\u8996",
  landingHighlightsAria: "\u7522\u54c1\u4eae\u9ede",
  landingVisualAria: "\u771f\u5be6\u7522\u54c1\u756b\u9762",
  landingStatementImageAlt: "\u5bb6\u5ead\u9031\u9810\u7b97\u6708\u7d50\u6458\u8981\u756b\u9762",
  landingTrendImageAlt: "\u5bb6\u5ead\u9031\u9810\u7b97\u6708\u652f\u51fa\u8da8\u52e2\u5716\u756b\u9762",
  landingTrialEyebrow: "\u8a66\u7528\u65b9\u5f0f",
  landingTrialTitle: "\u5f9e Google \u958b\u59cb",
  landingStep1Title: "\u4f7f\u7528 Google \u7e7c\u7e8c",
  landingStep1Copy: "\u4f7f\u7528\u5df2\u9a57\u8b49\u7684 Google \u5e33\u865f\uff0c\u4e0d\u9700\u8981\u53e6\u5916\u7533\u8acb\u8a66\u7528\u5bc6\u78bc\u3002",
  landingStep2Title: "\u76f4\u63a5\u958b\u555f\u8a66\u7528",
  landingStep2Copy: "\u7cfb\u7d71\u6703\u81ea\u52d5\u70ba\u4f60\u6e96\u5099\u5e33\u865f\u8207\u4e7e\u6de8\u7684\u5de5\u4f5c\u5340\u3002",
  landingStep3Title: "\u4e4b\u5f8c\u518d\u5347\u7d1a\u6b63\u5f0f\u6b0a\u9650",
  landingStep3Copy: "\u7ba1\u7406\u8005\u53ef\u5728\u6aa2\u8996\u5f8c\uff0c\u5c07\u8a66\u7528\u4f7f\u7528\u8005\u5347\u7d1a\u70ba\u6b63\u5f0f\u4f7f\u7528\u8005\u3002",
  landingContactEyebrow: "\u806f\u7d61\u6211\u5011",
  landingContactTitle: "\u652f\u63f4\u8207\u5c0e\u5165\u5354\u52a9",
  landingContactCopy:
    "\u65b0\u4f7f\u7528\u8005\u53ef\u76f4\u63a5\u900f\u904e Google \u958b\u59cb\u8a66\u7528\u3002\u5982\u9700\u6b63\u5f0f\u6b0a\u9650\u3001\u5c0e\u5165\u5354\u52a9\uff0c\u6216\u65e2\u6709\u5e33\u865f\u652f\u63f4\uff0c\u8acb\u806f\u7d61\u4f60\u7684\u670d\u52d9\u7ba1\u7406\u8005\u6216\u793a\u7bc4\u4e3b\u6301\u4eba\u3002",
  landingContactAction: "\u524d\u5f80\u767b\u5165\u9078\u9805",
  landingContactEmailBtn: "\u5bc4\u4fe1\u7d66\u6211\u5011",
  landingRequestTrialAccess: "\u7533\u8acb\u8a66\u7528",
  landingPrivateWorkspace: "\u79c1\u4eba\u5de5\u4f5c\u5340",
  landingLoginTitle: "\u767b\u5165\u4ee5\u7e7c\u7e8c",
  landingAuthCopySignedIn: "\u4f60\u5df2\u7d93\u767b\u5165\uff0c\u53ef\u4ee5\u76f4\u63a5\u9032\u5165\u5de5\u4f5c\u5340\u3002",
  landingAuthCopyGoogle: "\u4f7f\u7528 Google \u7e7c\u7e8c\uff0c\u4ee5\u5efa\u7acb\u6216\u958b\u555f\u4f60\u7684\u8a66\u7528\u5de5\u4f5c\u5340\u3002",
  landingAuthCopyOpen: "\u9019\u500b\u74b0\u5883\u76ee\u524d\u70ba\u958b\u653e\u6a21\u5f0f\uff0c\u53ef\u4ee5\u76f4\u63a5\u9032\u5165\u5de5\u4f5c\u5340\u3002",
  landingAuthCopyPassword: "\u7e7c\u7e8c\u524d\u5f80\u79c1\u4eba\u5de5\u4f5c\u5340\u3002\u5bc6\u78bc\u5c07\u5728\u5b89\u5168\u7684\u61c9\u7528\u7a0b\u5f0f\u767b\u5165\u756b\u9762\u4e2d\u8f38\u5165\u3002",
  landingAuthFootnoteGoogle: "Google \u8a66\u7528\u4f7f\u7528\u8005\u6703\u81ea\u52d5\u53d6\u5f97\u4e7e\u6de8\u5de5\u4f5c\u5340\u3002\u65e2\u6709\u5e33\u865f\u4ecd\u53ef\u4f7f\u7528\u5bc6\u78bc\u767b\u5165\u3002",
  landingAuthFootnotePassword: "\u5bc6\u78bc\u767b\u5165\u4fdd\u7559\u7d66\u65e2\u6709\u7ba1\u7406\u54e1\u6216\u5167\u90e8\u5e33\u865f\u3002",
  landingAuthFootnoteOpen: "\u6b64\u74b0\u5883\u76ee\u524d\u958b\u653e\u8a66\u7528\uff0c\u4f60\u53ef\u4ee5\u76f4\u63a5\u9032\u5165\u5de5\u4f5c\u5340\u3002",
  landingOpenWorkspace: "\u958b\u555f\u5de5\u4f5c\u5340",
  merchantRulesTitle: "\u5546\u5bb6\u5206\u985e\u8a18\u61b6",
  merchantRulesSub: "\u624b\u52d5\u8a2d\u5b9a\u7684\u5546\u5bb6\u5206\u985e\u898f\u5247\uff0c\u6703\u512a\u5148\u65bc\u7cfb\u7d71\u9810\u8a2d\u898f\u5247\u3002\u50c5\u9650\u76ee\u524d\u5de5\u4f5c\u5340\u751f\u6548\u3002",
  merchantRulesAdd: "\u65b0\u589e\u5546\u5bb6\u898f\u5247",
  merchantRulesMerchantPlaceholder: "\u4f8b\u5982\uff1aTPG INTERNET",
  merchantRulesMerchantInvalid: "\u8acb\u8f38\u5165\u5546\u5bb6\u540d\u7a31\u3002",
  merchantRulesDuplicate: "\u6b64\u5546\u5bb6\u5df2\u5b58\u5728\u5206\u985e\u898f\u5247\u3002",
  merchantRulesSaved: "\u5546\u5bb6\u5206\u985e\u898f\u5247\u5df2\u5132\u5b58\u3002",
  merchantRulesEmpty: "\u5c1a\u672a\u5efa\u7acb\u4efb\u4f55\u5546\u5bb6\u898f\u5247\u3002\u5728\u532f\u5165\u4ea4\u6613\u6642\u8b8a\u66f4\u5206\u985e\u4e26\u9078\u64c7\u300c\u8a18\u4f4f\u300d\u5373\u53ef\u5efa\u7acb\u3002",
  merchantRulesMerchant: "\u5546\u5bb6",
  merchantRulesCategory: "\u5206\u985e",
  merchantRulesAdded: "\u5efa\u7acb\u65bc",
  merchantRulesDelete: "\u522a\u9664",
  merchantRulesDeleteConfirm: "\u78ba\u5b9a\u522a\u9664\u6b64\u5546\u5bb6\u898f\u5247\uff1f",
  merchantRulesDeleteConfirmTitle: "\u522a\u9664\u5546\u5bb6\u898f\u5247",
  merchantRulesUpdated: "\u5546\u5bb6\u898f\u5247\u5df2\u66f4\u65b0",
  merchantRulesDeleted: "\u5546\u5bb6\u898f\u5247\u5df2\u522a\u9664",
  merchantRulesRememberTitle: "\u8a18\u4f4f\u5546\u5bb6\u5206\u985e",
  merchantRulesRememberMessage: (merchant, category) => `\u6c38\u9060\u5c07\u300c${merchant}\u300d\u5206\u985e\u70ba\u300c${category}\u300d\uff1f\uff08\u50c5\u9650\u76ee\u524d\u5de5\u4f5c\u5340\uff09`,
  merchantRulesRemember: "\u8a18\u4f4f\u6b64\u9078\u64c7",
  merchantRulesOnlyThis: "\u53ea\u9650\u672c\u7b14",
  merchantRulesUpdateTitle: "\u66f4\u65b0\u5546\u5bb6\u898f\u5247",
  merchantRulesUpdateMessage: (merchant, oldCat, newCat) => `\u5c07\u300c${merchant}\u300d\u7684\u898f\u5247\u5f9e\u300c${oldCat}\u300d\u66f4\u65b0\u70ba\u300c${newCat}\u300d\uff1f`,
  merchantRulesUpdate: "\u66f4\u65b0\u898f\u5247",
  merchantRulesSource: "\u4f86\u6e90",
  merchantRulesSourceUser: "\u4f7f\u7528\u8005",
  merchantRulesSourceSystem: "\u7cfb\u7d71",
  entryUnsavedTitle: "\u672a\u5132\u5b58\u7684\u8b8a\u66f4",
  entryUnsavedConfirm: "\u4f60\u6709\u672a\u5132\u5b58\u7684\u8b8a\u66f4\u3002\u78ba\u5b9a\u8981\u5207\u63db\u9031\u6b21\u55ce\uff1f\u672a\u5132\u5b58\u7684\u8cc7\u6599\u5c07\u6703\u907a\u5931\u3002",
};
